/**
 * Collection View
 */
class CollectionView extends AbstractProductsView {

	constructor(presenter) {

		super(presenter, "#product-cards-wrapper", "div.product-card");

		this.sortTitleAZ = $("#sort-title-az");
		this.sortTitleZA = $("#sort-title-za");

		/*
		 * Listeners
		 */

		this.sortTitleAZ.on("click", $.proxy(function(_event) {
			this.sortTitleAZ.addClass("d-none");
			this.sortTitleZA.removeClass("d-none");
			this.sortCards("ZA");
		}, this));

		this.sortTitleZA.on("click", $.proxy(function(_event) {
			this.sortTitleZA.addClass("d-none");
			this.sortTitleAZ.removeClass("d-none");
			this.sortCards("AZ");
		}, this));

	}

	/*
	 * Actions
	 */

	sortCards(sortType) {
		
		// we always update the list of cards, as they can be added dynamically via ajax and javascript
		var cards = $("div.product-card");
		if (sortType == "AZ") {
			this.sort(cards, "data-title", 1);
		} 
		else if (sortType == "ZA") {
			this.sort(cards, "data-title", -1);
		}
		this.cardsWrapper.html(cards);

	}
	
	enableFilteringAndSorting() {

		// enable the sort button
		this.sortTitleAZ.removeClass("disabled");
		this.sortTitleZA.removeClass("disabled");

	}

}